<template>
  <div class="overflow-x-auto">
    <div
      v-if="[...parentProtocols, ...childrenProtocols].length"
      style="min-width: max-content">
      <tree :tree="parentProtocols" reverse></tree>
      <div class="text-center main-chip">
        <span v-if="parentProtocols.length" class="chip-line-top"></span>
        <v-chip append-icon="mdi-star" color="orange">
          <span class="text-truncate" style="max-width: 200px">
            {{ protocol.name }}
          </span>
        </v-chip>
        <span v-if="childrenProtocols.length" class="chip-line-bottom"></span>
      </div>
      <tree :tree="childrenProtocols"></tree>
    </div>
    <div v-else class="text-disabled text-center">
      Пов'язані протоколи відсутні
    </div>
  </div>
</template>

<script lang="ts">
import Tree from '@/components/tree/index.vue'
import { useRelatedProtocols } from './relatedProtocols'
import { useProtocol } from '../protocol'
export default {
  name: 'RelatedProtocols',
  components: { Tree },
  setup() {
    const { protocol } = useProtocol()
    return { ...useRelatedProtocols(), protocol }
  },
}
</script>

<style scoped lang="scss"></style>
